"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAllGuardPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const use_t_1 = require("use-t");
const ConfirmPrompt_1 = require("@jsonjoy.com/ui/lib/4-card/ConfirmPrompt");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const previewClass = (0, nano_theme_1.rule)({
    d: 'inline',
    fontFamily: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
    fz: '13px',
    pd: '1px 6px',
    bdrad: '4px',
    mr: '0 2px',
    vrtAln: 'baseline',
});
const trim = (text, max) => {
    const collapsed = text.replace(/\s+/g, ' ').trim();
    if (collapsed.length <= max)
        return collapsed;
    return collapsed.slice(0, max) + '…';
};
const SelectAllGuardPopup = ({ state, action }) => {
    const [t] = (0, use_t_1.useT)();
    const styles = (0, context_1.useStyles)();
    const onConfirm = React.useCallback(() => state.confirm(), [state]);
    const onCancel = React.useCallback(() => state.cancel(), [state]);
    const title = action.kind === 'delete' ? t('Delete the whole document?') : t('Replace the whole document?');
    let body;
    if (action.kind === 'delete') {
        body = t('The entire document is selected. This will remove all content.');
    }
    else if (action.kind === 'replace-text') {
        const preview = trim(action.text, 24);
        body = (React.createElement(React.Fragment, null,
            t('The entire document will be replaced with'),
            ' ',
            React.createElement("span", { className: previewClass, style: { background: styles.g(0.5, 0.12), color: styles.g(0.1) } }, preview),
            "."));
    }
    else {
        body = t('The entire document will be replaced with the pasted content.');
    }
    return (React.createElement(ConfirmPrompt_1.ConfirmPrompt, { miniTitle: t('Confirm'), title: title, confirmLabel: action.kind === 'delete' ? t('Delete') : t('Replace'), cancelLabel: t('Cancel'), onConfirm: onConfirm, onCancel: onCancel }, body));
};
exports.SelectAllGuardPopup = SelectAllGuardPopup;
